import App_VNF from "./VNF/App.svelte";
import App_GUI from "./GUI/App.svelte";
import App_GUI_GROUPS from "./GUI_GROUPS/App.svelte";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let stopString = urlParams.get("stops");
let agency = stopString != null ? stopString.substring(0,3) : ''
let groupId = urlParams.get("groupId");

if(stopString == null && groupId == null){
  console.log("Malformed URL");
} else if(stopString != null){
  let agency = stopString != null ? stopString.substring(0,3) : ''

  // Backwqard compatibility for url with stops=VNF*****
  agency = agency == 'VNF' ? 'MOB' : agency;

  if (agency == 'GUI') {
    const app = new App_GUI({
      target: document.body,
    });
  } else if (agency == 'MOB' || agency == 'AVE' || agency == 'CAV' || agency == 'BAR' || agency == 'BRA'){
    const app = new App_VNF({
      target: document.body,
    });
  } else {
    console.log("Agency not allowed");
  }
} else if(groupId != null){
  const app = new App_GUI_GROUPS({
    target: document.body,
  });
} else {
  console.log("Agency not allowed");
}

export default app;
